import { useDispatch, useSelector } from "react-redux";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { useEffect } from "react";
import useOrganizationRelationshipColumn from "./Hooks/useOrganizationRelationshipColumn";
import UserFilter from "../../Settings/UserManagement/Users/UserFilter";
import { getOrgId, getOrganizationId } from "../../../Utils/CommonUtils";
import { getOrgRelationshipListing } from "./OrgRelationshipService";
import { resetFormState } from "../../../slices/common/reducer";
import AddNewOrgRelationshipModal from "./Modal/AddNewOrgRelationshipModal";

const OrganizationListing = () => {
  const dispatch = useDispatch();
  const { organizationRelationshipColumns } =
    useOrganizationRelationshipColumn();
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  // const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);
  const organizationRelationshipData = useSelector(
    (state) => state.organizationRelationship.organizationRelationshipData
  );
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;
  // const orgType = getOrganizationType();

  // const totalRows = organizationRelationshipData ? organizationRelationshipData.length : 0;

  useEffect(() => {
    if (organizationId) {
      getOrgRelationshipListing(organizationId);
    }
    dispatch(resetFormState());
  }, [organizationId, triggerRender]);

  return (
    <div>
      <CommonHeader
        newButton={true}
        buttonTitle={"New Org Relationship"}
        filterComponent={<UserFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={organizationRelationshipColumns}
          data={organizationRelationshipData}
          // apiTabData={apiTabData}
          // paginatedApi
          // filterApi
          // filterApiEntity={"USR"}
          // filterApiListEntity={"USR"}
          // filterApiFunction={setUsersData}
          // filterApiService={getListingByOrgId}
          // filterForm={filterForm}
          // totalRows={totalRows}
          // status={id}
          // statusColumn={"status"}
          // download
          // handleDownload={handleDownload}
          // hideTabs
          // hideTabsWrapper={true}
        />
      </div>
      {(modalShow || editShow) && <AddNewOrgRelationshipModal />}
    </div>
  );
};

export default OrganizationListing;
